import { adjustSignaturesData } from './adjustSignaturesData';

export const getAllSignaturesRequest = profileId => {
  return adjustSignaturesData(profileId);
};
